<br />
<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>
<div fxLayout="row wrap" class="matero-row">
  &nbsp;&nbsp;
  <button mat-raised-button color="primary" title="Add Sample" (click)="addRetest()" [disabled]="authService.isReadOnly()"><mat-icon>add</mat-icon> Add Scheduled Retest</button>
</div>
<mat-card>
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-row" style="overflow-x: auto;">
    <strong class="noMarginHeader">Results ({{resultSize}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTable($event)" placeholder="Filter Results" matInput />
    </mat-form-field>
    &nbsp;&nbsp;&nbsp;&nbsp; <a (click)="load()"><mat-icon>refresh</mat-icon> </a>
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-row>Results </mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Retest Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editRetest(result.id)" title="Edit Sample {{result.id}}">{{result.id}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="orgininalSampleId">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Original <br /> Sample Id</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          <span *ngIf="result.householdId == 0">&nbsp;</span>
          <span *ngIf="result.orgininalSampleId > 0">
            <a href="javascript:void(0)" (click)="editSample(result.orgininalSampleId)" title="View Original Sample Id {{result.orgininalSampleId}}">{{result.orgininalSampleId}}</a>
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="retestSampleId">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Retest <br /> Sample Id</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          <span *ngIf="result.retestSampleId == 0">&nbsp;</span>
          <span *ngIf="result.retestSampleId > 0">
            <a href="javascript:void(0)" (click)="editSample(result.retestSampleId)" title="View Retest Sample Id {{result.retestSampleId}}">{{result.retestSampleId}}</a>
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="voucherId">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Voucher</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          <span *ngIf="result.voucherId == 0">&nbsp;</span>
          <span *ngIf="result.voucherId > 0 && voucherId == 0">
            <a href="javascript:void(0)" (click)="editVoucher(result.voucherId)" title="View Voucher Id {{result.voucherId}}">{{result.voucherIdentifier}}</a>
          </span>
          <span *ngIf="result.voucherId > 0 && voucherId != 0">
            {{result.voucherIdentifier}}
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="householdId">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Household Id</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          <span *ngIf="result.householdId == 0">&nbsp;</span>
          <span *ngIf="result.householdId > 0">
            <a href="javascript:void(0)" (click)="editHousehold(result.householdId)" title="View Household Id {{result.householdId}}">{{result.householdId}}</a>
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="retestYear">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Year</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.retestYear}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="retestQuarter">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Quarter</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          Q{{result.retestQuarter}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="tier">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Tier</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          Tier {{result.tier}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="dueBy">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Due By</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          {{result.dueBy}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="complete">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Complete</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          <span *ngIf="result.isComplete" class="text-green-400">Yes</span>
          <span *ngIf="!result.isComplete" class="text-red-400">No</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="completedDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Completed Date</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          <span *ngIf="result.isComplete">{{result.completedDate}}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="highestNitrate">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Highest Voucher Nitrate</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
          <span [hidden]="result.highestNitrateSampleId == 0">
            Value: <a href="javascript:void(0)" (click)="editSample(result.highestNitrateSampleId)" title="View Highest Sample {{result.highestNitrateSampleId}}">{{result.highestNitrateValue}}</a>
            <br />
            Tier: {{result.highestNitrateTier}}
            <mat-icon class="error" [hidden]="result.tier==result.highestNitrateTier">warning</mat-icon>
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let result">
          &nbsp;&nbsp;
          <a href="javascript:void(0)" (click)="deleteRetest(result.id)" title="Delete Retest Schedule {{result.id}}" *ngIf="!authService.isReadOnly()">
            <mat-icon>delete</mat-icon>
          </a>
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>